const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/

const DATE_BOUNDARY_TIMES = {
  start: '00:00:00',
  end: '23:59:59',
} as const

export type DateBoundary = keyof typeof DATE_BOUNDARY_TIMES

/**
 * Adds the requested time only to date-only values. Downstream filters may
 * pass through more than one serializer, so full datetimes must be preserved.
 */
export function withDateBoundary(value: string, boundary: DateBoundary): string {
  return DATE_ONLY_PATTERN.test(value) ? `${value}T${DATE_BOUNDARY_TIMES[boundary]}` : value
}
